import { render, staticRenderFns } from "./AcceptanceFollowList.vue?vue&type=template&id=42f42da1&scoped=true&"
import script from "./AcceptanceFollowList.vue?vue&type=script&lang=js&"
export * from "./AcceptanceFollowList.vue?vue&type=script&lang=js&"
import style0 from "./AcceptanceFollowList.vue?vue&type=style&index=0&id=42f42da1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f42da1",
  null
  
)

export default component.exports